import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M28 62 L28 30 L44 30 C50 30 54 34 54 39 C54 43 51 46 47 47 L54 62 L48 62 L42 49 L33 49 L33 62 L34 62 Z M33 34 L33 45 L44 45 C47 45 49 43 49 40 C49 37 47 34 44 34 L33 34 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
